<template>


    <div class="page-content">   
		<div data-height="150" class="page-title-bg bg-20"><!-- image --></div>
		<div data-height="150" class="page-title-bg dark-mode-tint"><!-- contrast for dark mode --></div>
		<div data-height="150" class="page-title-bg opacity-90 bg-highlight"><!-- background color --></div>
		
		<div class="page-title-small color-white bottom-30">
			<h1><i class="fa fa-arrow-left back-button"></i>Ingreso datos OT {{ idcotizacionvehiculo }}</h1>
			<a href="/dashboard" data-menu="menu-main" class="shadow-huge scale-box bg-fade-gray2-dark" v-bind:style="userimageurl"></a>
		</div>
	
     
		<div class="content-boxed">


  			<div class="content bottom-0">
                    <form onsubmit="event.preventDefault();" class="contactForm" id="Formsubmit">
				
				<div data-height="280" class="caption caption-margins round-medium shadow-large">
					<div class="caption-bottom left-20 bottom-15">
						<p class="bottom-0 color-white opacity-50 under-heading font-12">{{ fecha }}, {{ sucursal }}</p>
						<h1 class="color-white bottom-0 bolder">{{ OT.marca }}</h1>
						<h1 class="color-white bottom-0 bolder">{{ OT.modelo }}</h1>
						<h1 class="color-white bottom-0 bolder">{{ OT.version }}</h1>
						<h1 class="color-white bottom-0 bolder">{{ OT.agno }}</h1>
						<p class="bottom-0 color-white opacity-50 under-heading font-12">{{ OT.vin }}</p>
						<h1 class="color-white bottom-0 bolder">{{ OT.placapatente }}</h1>
						<a href="#" class="opacity-75 button bg-blue1-dark button-m button-full round-small bottom-10 contactSubmitButton" style="left:-30px;width:110%;top:25px" @click="editvehiculo" data-formId="dataForm">Editar vehículo</a>
					</div>
					<div class="caption-overlay bg-black opacity-75">
					</div>
					<div class="bg-black opacity-75"></div>
					<div class="caption-bg bg-29"></div>
				</div>   

				<div data-height="310" class="caption caption-margins round-medium shadow-large">
					<div class="caption-bottom left-20 bottom-15">
						<h2 class="color-white bottom-0 bolder">{{ OT.nombre }}</h2>
						<h2 class="color-white bottom-0 bolder">{{ OT.paterno }}</h2>
						<h2 class="color-white bottom-0 bolder">{{ OT.materno }}</h2>
						<h2 class="color-white bottom-0 bolder">{{ Direccioncliente.direccion }} {{ Direccioncliente.numero }} <span v-if="casa">casa/dpto. {{ Direccioncliente.casa }}</span> </h2>
						<h2 class="color-white bottom-0 bolder">{{ Direccioncliente.ciudad }}</h2>
						<h2 class="color-white bottom-0 bolder">{{ Direccioncliente.comuna }}</h2>
						<br>
						<p class="bottom-0 color-white under-heading font-12">{{ OT.fono1 }}</p>
						<p class="bottom-0 color-white under-heading font-12">{{ OT.fono2 }}</p>
						<p class="bottom-0 color-white under-heading font-12">{{ OT.email }}</p>
						<a href="#" class="opacity-75 button bg-magenta2-dark button-m button-full round-small bottom-10 contactSubmitButton" style="left:-30px;width:110%;top:25px" @click="editcliente" data-formId="dataForm">Editar cliente</a>
					</div>
					<div class="caption-overlay bg-black opacity-75"></div>
					<div class="caption-bg bg-27"></div>
				</div>   








				<div class="contact-form">



					<div > 


					</div>

                </div>







                <div class="contact-form">
						<div class="content-boxed">
								<a href="#" class="button bg-blue2-dark button-m button-full round-small bottom-10 shadow-small contactSubmitButton" @click="siguiente" data-formId="dataForm">Siguiente</a>
						</div>

                </div>
			</form>			

            </div>

 


    	</div>
		
    </div>


</template>

<script>

import * as db from "./../../database.js";
import * as validate from "./../../validate.js";

export default {
	data() {
      return {
		params:'{"valkey":"'+localStorage.getItem('idcotizacionvehiculo')+'","tablename":"T_VEH_COTIZACIONVEHICULO","entity":"8","classifications":"39"}',
		idcotizacionvehiculo: localStorage.getItem('idcotizacionvehiculo'),
		idagenda:localStorage.getItem('idagenda'),
		userimageurl:"background-image:url("+db.getServerHTTP()+JSON.parse(localStorage.getItem('user')).imageurl+")",  
		codsucursal:JSON.parse(localStorage.getItem('user')).codsucursal,
		sucursal:JSON.parse(localStorage.getItem('user')).sucursal,

		fecha:localStorage.getItem('fechaagenda'),
		Direccioncliente:{},
		OT:{}
		}
	},

	mounted() {      

		let strSql;

		strSql="SELECT V.IN_COD_VEHICULO codvehiculo,"
			+"IN_KILOMETRAJEVEHICULO_COTIZACIONVEHICULO kilometraje,"
			+"DT_FECHAENTREGAOT_COTIZACIONVEHICULO fechaentregaot,"
			+"CONVERT(VARCHAR(10),DT_FECHAENTREGAOT_COTIZACIONVEHICULO,120) fechaentrega,"
			+"CONVERT(VARCHAR(10),DT_FECHAENTREGAOT_COTIZACIONVEHICULO,108) horaentrega,"
			+"COT.IN_ESORDENTRABAJOINTERNA_COTIZACIONVEHICULO datatipoot,"
			+"CLI.IN_COD_CLIENTE codcliente,"			
			+"COT.IN_COD_TIPOTRABAJO datatipotrabajo,"
			+"CLI.ST_NOMBRE_CLIENTE nombre,"
			+"CLI.ST_APEPAT_CLIENTE paterno,"
			+"CLI.ST_APEMAT_CLIENTE materno,"
			+"CLI.ST_FONO1_CLIENTE fono1,"
			+"CLI.ST_FONO2_CLIENTE fono2,"
			+"CLI.ST_EMAIL_CLIENTE email,"
			+"(SELECT ST_DESC_DETALLECLASIFICACION D FROM T_GEN_DETALLECLASIFICACION D WHERE IN_COD_DETALLECLASIFICACION=V.IN_VALORNIVEL1_VEHICULO) marca,"
			+"(SELECT ST_DESC_DETALLECLASIFICACION D FROM T_GEN_DETALLECLASIFICACION D WHERE IN_COD_DETALLECLASIFICACION=V.IN_VALORNIVEL2_VEHICULO) modelo,"
			+"(SELECT ST_DESC_DETALLECLASIFICACION D FROM T_GEN_DETALLECLASIFICACION D WHERE IN_COD_DETALLECLASIFICACION=V.IN_VALORNIVEL3_VEHICULO) version,"
			+"V.IN_VALORNIVEL1_VEHICULO codmarca,"
			+"V.IN_VALORNIVEL2_VEHICULO codmodelo,"
			+"V.IN_VALORNIVEL3_VEHICULO codversion,"
			+"IN_AGNOFABRICACION_VEHICULO agno,ST_PLACAPATENTE_VEHICULO placapatente,ST_NVIN_VEHICULO vin"
			+" FROM T_VEH_COTIZACIONVEHICULO COT,T_VEH_VEHICULO V,T_CLI_CLIENTE CLI"
			+" WHERE COT.IN_COD_COTIZACIONVEHICULO="+this.idcotizacionvehiculo
			+" AND COT.IN_COD_VEHICULO=V.IN_COD_VEHICULO"
			+" AND COT.IN_COD_CLIENTE=CLI.IN_COD_CLIENTE"

		db.getQuery(strSql)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
			this.OT=result.data.data
			this.seleccionmarca=this.OT.marca;
			this.seleccionmodelo=this.OT.modelo;
			//this.seleccionmodelo=this.OT.version;
			this.seleccionagno=this.OT.agno;
			this.codcliente=this.OT.codcliente;
		}}); 

		strSql="SELECT TOP 1 ST_DESC_DIRECCION direccion,ST_CASADPTO_DIRECCION casa,IN_NUMERO_DIRECCION numero,"
			+ "C1.ST_DESC_DETALLECLASIFICACION ciudad," 
			+ "C2.ST_DESC_DETALLECLASIFICACION comuna" 
			+" FROM T_VEH_COTIZACIONVEHICULO COT,T_CLI_CLIENTE CLI,T_GEN_DIRECCION D,T_GEN_DETALLECLASIFICACION C1,T_GEN_DETALLECLASIFICACION C2"
			+" WHERE COT.IN_COD_COTIZACIONVEHICULO="+this.idcotizacionvehiculo
			+" AND COT.IN_COD_CLIENTE=CLI.IN_COD_CLIENTE"
			+" AND D.IN_CODENTIDAD_DIRECCION=CLI.IN_COD_CLIENTE"
			+" AND (IN_ENTIDAD_DIRECCION=2 OR IN_ENTIDAD_DIRECCION=3)" 
			+" AND D.IN_VALORNIVEL1REGIONCOMUNA_DIRECCION=C1.IN_COD_DETALLECLASIFICACION"
			+" AND D.IN_VALORNIVEL2REGIONCOMUNA_DIRECCION=C2.IN_COD_DETALLECLASIFICACION"

		db.getQuery(strSql)   .then(result => {if (result.data.err!=""){
			//alert("El cliente no tiene dirección");
			//alert(result.data.err);
			console.log (result.data.err);}else{
			this.Direccioncliente=result.data.data


		}}); 

},


	methods: {
		editvehiculo()
	  	{
			localStorage.setItem('searchplacapatente',"");
			localStorage.setItem('editcodvehiculo',this.OT.codvehiculo);

			window.location="/Editvehiculo"
		},

		editcliente()
	  	{
			localStorage.setItem('editcodcliente',this.OT.codcliente);

			window.location="/Editcliente"
		},

		siguiente()
	  	{

		var strErr=validate.check(Formsubmit)
			if (strErr==""){
				db.getFx("ot.crearVehiculo",'{"placapatente":"'+this.OT.placapatente+'","agno":"'+this.OT.agno+'","codmarca":"'+this.OT.codmarca+'","codmodelo":"'+this.OT.codmodelo+'"}')   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
					let codusuario=JSON.parse(localStorage.getItem('user')).codusuario;
					console.log("Funciona")
					db.getFx("agenda.asignarasesor",'{"codagenda":"'+this.idagenda+'","codasesor":"'+codusuario+'"}')   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
						window.location="/Wizardot2data"
					}});

				}});
			}
	/*
			let codusuario=JSON.parse(localStorage.getItem('user')).codusuario;
			db.getFx("agenda.asignarasesor",'{"codagenda":"'+this.idagenda+'","codasesor":"'+codusuario+'"}')   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
				window.location="/Wizardot2data"
			}});
	*/
			//Ingresar OT
	  	},



	}
}

</script>
